<template>
  <v-app>

    <v-app-bar
      app
      color="white"
      dense
      v-if="getLogeado"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      Sistema de administración v2.5
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <!-- Menu lateral izquierdo -->
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      app
      v-if="getLogeado"
    >

      <v-list-item>
        <v-list-item-content>
          <v-img src="" v-if="!mini"></v-img>
          <v-avatar
            size="40"
            v-else="mini"
            color="white"
          >
            <img src="">
          </v-avatar>
        </v-list-item-content>

        <v-btn icon @click.stop="mini = !mini" color="primary">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item class="px-2" @click="verMiPerfil( )">
        <v-list-item-avatar>
          <v-img
            :src="avatar"
          ></v-img>
        </v-list-item-avatar>

        <v-list-item-content v-if="getdatosUsuario">
          <v-list-item-title>
            {{ getdatosUsuario.nomuser }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ getdatosUsuario.puesto }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav class="mr-0">
        <v-list-group
          v-for="item in menu"
          :key="item.title"
          v-model="item.active"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            color="primary"
            v-for="child in item.subemnu"
            :key="child.title"
            :to="{ name: child.path }"
            :class="`pl-2 ${ child.color ? child.color : 'grey lighten-3' }`"
          >

            <v-list-item-icon>
              <v-icon color="primary">mdi mdi-circle-medium theme--light</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <!-- REGLAMENTO -->
      <v-list dense nav class="mr-0">
        <v-list-item @click="salir" class="primary white--text" dark>
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      


    </v-navigation-drawer>

  </v-app>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
    name: 'App',

    components: {
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({
      //
      model: null,
      dialog: false,
      draw: false,

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      radio:1,
      drawer: true,
      drawer2:false,
      mini:false,

      accesos: []
     
    }),

    created( ){
      this.initialize()
    },

    methods:{
      ...mapActions('login',['salirLogin']),

      salir(){
        this.salirLogin()
        this.$router.push({name:'login'})
      },

      initialize () {
        this.usuarios = []
        this.cargar = true
        this.$http.get('accesos.all').then(response=>{
          this.accesos = response.body
        }).catch(error=>{this.cargar = false})
      },

      verMiPerfil( ){

        this.$router.push({
          name: 'MiPerfil'
        })

      },
    },

    computed:{
      ...mapGetters('login',['getdatosUsuario','getLogeado']),

      avatar(){
        return "https://ui-avatars.com/api/?background=primary&color=fff&rounded=true&format=svg&name=" + this.getdatosUsuario.nomuser
      },

      accesoWataje( ){
        const existenAccesos = this.accesos.find( el => el.id == this.getdatosUsuario.id )

        let permisos = existenAccesos ? existenAccesos.accesos : []

        return permisos.find( el => el.idruta == 3 )
      },

      menu(){

        return this.getdatosUsuario.menu

      }
    }
  };
</script>
<style>

  body {
    font-family: 'Poppins', sans-serif !important;
  }

  main{
    background: #f8f9fa ;
    font-family: 'Poppins', sans-serif !important;
  }

  html{
    background: #f8f9fa;
    font-family: 'Poppins', sans-serif !important;
  }

  .v-main__wrap{
    background: #f8f9fa !important;
    font-family: 'Poppins', sans-serif !important;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
    font-family: 'Poppins', sans-serif !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
    font-family: 'Poppins', sans-serif !important;
  }

  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
    font-family: 'Poppins', sans-serif !important;
  }
  .v-application--is-ltr .v-list--dense.v-list--nav .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 10px !important;
    font-family: 'Poppins', sans-serif !important;
  }

 
  .v-navigation-drawer__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-navigation-drawer__content::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-button:increment,.v-navigation-drawer__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
  }


  .subrayado {
    text-decoration: underline;
  }

  #idScrollApp::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > #idScrollApp::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar-button:increment,#idScrollApp::-webkit-scrollbar-button{
    display: none;
  }

  #idScrollApp::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  a .v-list-item .v-list-item--link .theme--light{
    padding-left: 0px !important;
  }

</style>